export default __webpack_public_path__ + "static/media/02.5b55d3d5.png";